import * as React from 'react'
import Paper from '@mui/material/Paper'
import { DetailsIcon } from '../Icons/DetailsIcon'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export function DetailsHeader() {
  return (
    <Box p={2} pt={1.2} pb={0}>
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          width: '100%',
          minWidth: '572px',
          height: '72px',
          backgroundColor: '#E7F5F6',
          border: '1px solid #E0E0E0',
          borderRadius: '16px',
        }}
      >
        <Box display="flex" height="100%" alignItems="center">
          <DetailsIcon />
          <Typography
            variant="h6"
            justifyContent="center"
            alignItems="center"
            paddingLeft={'18px'}
          >
            Property Details
          </Typography>
        </Box>
      </Paper>
    </Box>
  )
}
